// Internal Dependencies
import { IsEmpty } from './checks';

const CLOUDFRONT = process.env.REACT_APP_CLOUDFRONT_URL;
const DEV_CLOUDFRONT = process.env.REACT_APP_DEV_CLOUDFRONT_URL;

const convert = {
  imageResizeUrl(imageUrl = '', width = 500, height = 500) {
    try {
      if (IsEmpty(imageUrl)) {
        return imageUrl;
      } else if (imageUrl.indexOf(CLOUDFRONT) < 0 && imageUrl.indexOf(DEV_CLOUDFRONT) < 0) {
        // possibly a local image
        return imageUrl;
      } else if (imageUrl.indexOf(DEV_CLOUDFRONT) >= 0 || imageUrl.indexOf(CLOUDFRONT) !== 0) {
        // Do no resize for dev. Also, don't resize if image is not from our prod cloudfront.
        return imageUrl;
      } else {
        const s3Key = imageUrl.substr(CLOUDFRONT.length + 1);
        return `${CLOUDFRONT}/${width}x${height}/${s3Key}`;
      }
    } catch (err) {
      return imageUrl;
    }
  },
};

export default convert;
